import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

const ContactItem = ({ icon: Icon, title, value, delay }) => (
  <motion.div
    initial={{ opacity: 0, x: -20 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.5, delay }}
    viewport={{ once: true }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 2,
        mb: 3,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 45,
          height: 45,
          borderRadius: 2,
          backgroundColor: 'rgba(255, 107, 0, 0.1)',
          color: 'primary.main',
        }}
      >
        <Icon sx={{ fontSize: 24 }} />
      </Box>
      <Box>
        <Typography
          variant="subtitle2"
          sx={{
            color: 'rgba(255, 255, 255, 0.7)',
            mb: 0.5,
            fontWeight: 500,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'common.white',
            fontWeight: 400,
          }}
        >
          {value || 'Loading...'}
        </Typography>
      </Box>
    </Box>
  </motion.div>
);

const ContactInfo = ({ data }) => {
  const contactItems = [
    { icon: LocationOnIcon, title: 'Address', value: data?.address },
    { icon: PhoneIcon, title: 'Phone', value: data?.phone },
    { icon: EmailIcon, title: 'Email', value: data?.email },
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 3, md: 4 },
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.02)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.05)',
        borderRadius: 2,
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        <Typography
          variant="h5"
          sx={{
            mb: 4,
            color: 'common.white',
            fontWeight: 600,
          }}
        >
          Contact Information
        </Typography>
      </motion.div>

      {contactItems.map((item, index) => (
        <ContactItem
          key={item.title}
          icon={item.icon}
          title={item.title}
          value={item.value}
          delay={index * 0.1}
        />
      ))}
    </Paper>
  );
};

export default ContactInfo;
